import { Component, OnInit } from '@angular/core';
import {DispatchPendingModel} from '../shared/dto/dispatch-pending.model';
import {TokenStorageService} from '../shared/service/token-storage.service';
import {ApprovalService} from '../service/approval.service';

@Component({
  selector: 'app-dispatch-process',
  templateUrl: './dispatch-process.component.html',
  styleUrls: ['./dispatch-process.component.scss']
})
export class DispatchProcessComponent implements OnInit {
  public userName: string;
  public type: string;
  public newReqCounts: number = 0;
  public renewReqCounts: number = 0;
  public dulicateReqCounts: number = 0;
  public scanPendingList: DispatchPendingModel[];
  scanPending: DispatchPendingModel = new DispatchPendingModel();

  constructor( private tokenStorageService: TokenStorageService,
               private approvalService: ApprovalService) {
    this.userName=this.tokenStorageService.getUserObjectToken().username;
  }

  ngOnInit() {
    this.getNewScanPendingList();
    this.getRenewScanPendingList();
    this.getDuplicateScanPendingList();
  }

  getNewScanPendingList() {
    this.scanPending.sidNo = null;
    this.scanPending.cdcNo = null;
    this.scanPending.name = null;
    this.scanPending.nic =  null;
    this.scanPending.loginUser = this.userName;
    this.scanPending.type = "New";

    this.approvalService.searchScanPendingData(this.scanPending).subscribe(
      (result: any ) => {
        this.scanPendingList = result;
        this.newReqCounts = result.length;
      }
    );
  }

  getRenewScanPendingList() {
    this.scanPending.sidNo = null;
    this.scanPending.cdcNo = null;
    this.scanPending.name = null;
    this.scanPending.nic =  null;
    this.scanPending.loginUser = this.userName;
    this.scanPending.type = "Renew";

    this.approvalService.searchScanPendingData(this.scanPending).subscribe(
      (result: any ) => {
        this.scanPendingList = result;
        console.log(this.scanPendingList.length);
        this.renewReqCounts = result.length;
      }
    );
  }

  getDuplicateScanPendingList() {
    this.scanPending.sidNo = null;
    this.scanPending.cdcNo = null;
    this.scanPending.name = null;
    this.scanPending.nic =  null;
    this.scanPending.loginUser = this.userName;
    this.scanPending.type = "Duplicate";

    this.approvalService.searchScanPendingData(this.scanPending).subscribe(
      (result: any ) => {
        this.scanPendingList = result;
        console.log(this.scanPendingList.length);
        this.dulicateReqCounts = result.length;
      }
    );
  }
}
